import { IConfigurationRegistry } from "../../../../../base/domain/configuration";
import { IConfiguration } from "../../../../domain/configuration";
import { QuestionnaireExtendedTranslator } from "./QuestionnaireExtendedTranslator";
import { Translator } from "./Translator";

export class TranslatorFactory {
  constructor(private readonly _configurationRegistry: IConfigurationRegistry<IConfiguration>) {}

  private _instance: Translator | null = null;

  create(): Translator {
    if (!this._instance) {
      const configuration = this._configurationRegistry.getConfigurationService().getConfiguration();
      this._instance = configuration.formatEditor.extensions.questionnaire.isEnable
        ? new QuestionnaireExtendedTranslator()
        : new Translator();
    }
    return this._instance;
  }
}
